import React from "react";
import { Input } from "@revvsales/components";
import {
  RevvForm,
  // ErrorMessages,
  ReactSelect,
} from "../../../../commonComponents";

import {
  CustomFieldComponentRules,
  CustomFieldComponentMessages,
} from "../../DynamicField/DynamicFieldComponents/CustomFieldRulesMap";

import { DOCUMENTS } from "../../../../constants";

const { FORM_FIELDS_DEFAULT_VALUES } = DOCUMENTS;

export default class PeriodFormMode extends React.Component {
  state = {
    periodTextFieldValues: this.props.initialProps.value
      ? JSON.parse(JSON.stringify(this.props.initialProps.value))
      : JSON.parse(JSON.stringify(FORM_FIELDS_DEFAULT_VALUES.PERIOD)),
  };

  _handleOnBlur = (event, value, handleBlur) => {
    handleBlur(event);
    // If the field is validated & there is a value then only
    // make an API call and update the redux store
    const updatedValue = {
      ...value,
      periodValue: parseInt(value.periodValue, 10),
    };
    const { id } = this.props.initialProps;
    const { periodValue, periodUom } = updatedValue;
    const combinedValue = `${periodValue || ""} ${periodUom || ""}`;
    this.props._updateDynamicFieldsInDoc(id, updatedValue);
    this._checkForPeriodValueUpdateField(updatedValue, combinedValue);
  };

  _handleOnChange = (value, defaultValue, handleChangeByName) => {
    handleChangeByName(value, "periodUom");
    // If there is a value then only
    // make an API call and update the redux store
    const updatedValue = {
      ...defaultValue,
      periodValue: parseInt(defaultValue.periodValue, 10),
    };
    if (defaultValue.periodUom) {
      const { id } = this.props.initialProps;
      const { periodValue, periodUom } = updatedValue;
      const combinedValue = `${periodValue || ""} ${periodUom || ""}`;
      this.props._updateDynamicFieldsInDoc(id, updatedValue);
      this._checkForPeroidUomUpdateField(updatedValue, combinedValue);
    }
  };

  _checkForPeriodValueUpdateField = (currentValue, combinedValue) => {
    const { id, value: initialValue } = this.props.initialProps;
    if (initialValue && initialValue.periodValue !== currentValue.periodValue) {
      this.props._updateField(id, currentValue, "periodValue");
    } else if (
      this.state.periodTextFieldValues.periodValue !== currentValue.periodValue
    ) {
      this.props._updateField(id, currentValue, "periodValue");
      this._checkChangeStatus(combinedValue);
    }
  };

  _checkForPeroidUomUpdateField = (currentValue, combinedValue) => {
    const { id, value: initialValue } = this.props.initialProps;
    if (initialValue && initialValue.periodUom !== currentValue) {
      this.props._updateField(id, currentValue, "periodUom");
      this._checkChangeStatus(combinedValue);
    } else if (this.state.periodTextFieldValues.periodUom !== currentValue) {
      this.props._updateField(id, currentValue, "periodUom");
    }
  };

  _checkChangeStatus = value => {
    if (!value.split(" ").includes("")) {
      this.props.filledStatus(true);
    } else this.props.filledStatus(false);
  };

  render() {
    const { id, /* docIsLocked */ meta } = this.props.initialProps;
    return (
      <React.Fragment>
        <RevvForm
          revvFormId={id}
          initialFormValue={this.state.periodTextFieldValues}
          customFieldName="PERIOD"
          customFieldComponentRules={CustomFieldComponentRules}
          validateOnChange
          customFieldComponentMessages={CustomFieldComponentMessages}
          render={formProps => {
            const {
              handleChangeByName,
              handleChange,
              handleBlur,
              messages,
              values,
            } = formProps;
            return (
              <React.Fragment>
                <div className="composite-field-period">
                  <div className="composite-field-period-val">
                    <Input
                      id={id}
                      name="periodValue"
                      type="number"
                      className="form-mode-input"
                      // {`form-mode-input ${
                      //   messages.periodValue &&
                      //   messages.periodValue.required !== ""
                      //     ? "danger-border"
                      //     : ""
                      // }`}
                      placeholder="Enter period"
                      value={
                        values && values.periodValue
                          ? values.periodValue
                          : "Period Value"
                      }
                      onChange={event => handleChange(event)}
                      onBlur={event =>
                        this._handleOnBlur(
                          event,
                          values,
                          handleBlur,
                          !messages.periodValue,
                        )
                      }
                      disabled={this.props.isLocked}
                      data-test="periodFormMode-periodValue"
                      autoFocus
                    />
                    {/* <div>
                      {messages.periodValue && (
                        <ErrorMessages
                          messages={messages.periodValue.required}
                        />
                      )}
                    </div> */}
                  </div>

                  <div className="composite-field-period-uom">
                    <ReactSelect
                      id={id}
                      name="periodUom"
                      isSearchable
                      options={meta.options}
                      value={values && values.periodUom ? values.periodUom : ""}
                      onChange={event =>
                        this._handleOnChange(
                          event.value,
                          values,
                          handleChangeByName,
                        )
                      }
                      isDisabled={this.props.isLocked}
                      data-test="periodFormMode-periodUom"
                    />
                  </div>
                </div>
              </React.Fragment>
            );
          }}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DocumentV2/FormView/FormModeComponents/PeriodFormMode.js